import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black mb-0 mt-auto h-full" }
const _hoisted_2 = { class: "flex flex-col mt-auto items-center w-full px-6 space-y-14" }
const _hoisted_3 = { class: "flex flex-col items-center space-y-5" }
const _hoisted_4 = { class: "flex w-full flex-col space-y-2" }
const _hoisted_5 = { class: "flex w-full px-5 text-brand-light-gray text-center items-center" }
const _hoisted_6 = {
  key: 0,
  class: "w-full text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "w-full text-center"
}
const _hoisted_8 = {
  key: 2,
  class: "w-full text-center"
}
const _hoisted_9 = {
  key: 3,
  class: "w-full text-center"
}
const _hoisted_10 = { class: "flex flex-col space-y-2 w-full items-center" }

import {IonContent, IonPage, useIonRouter} from '@ionic/vue';
import LogoMark from "@/components/LogoMark.vue";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {AccountType} from "@/definitions/AccountType";
import ApiService from "@/services/api/apiService";
import InputCheckbox from "@/components/InputCheckbox.vue";
import {computed, ref} from "vue";
import {Preferences} from "@capacitor/preferences";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountOnboardingPage',
  setup(__props) {

const ionRouter = useIonRouter()

const accountType = ref([])

const busy = ref(false)

const forward = async () => {
  if (busy.value) return
  busy.value = true
  const key = PreferenceKey.OnboardingAccountType
  const value = accountType.value[0]
  try {
    await Preferences.set({
      key,
      value
    })
    await ionRouter.navigate('/account/onboarding/name', 'forward', 'push')
    await ApiService.User().setPreference(key, value)
  } catch (e) {
    //
    console.log(e)
  } finally {
    busy.value = false
  }
}

const accountTypes = [
  {
    text: 'Individual',
    value: AccountType.Individual,
  },
  {
    text: 'Joint',
    value: AccountType.Joint,
  },
  {
    text: 'Club',
    value: AccountType.Club,
  },
  {
    text: 'Host',
    value: AccountType.Host,
  }
]

const canProgress = computed(() => {
  return accountType.value.length === 1
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(LogoMark),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2 text-center" }, [
                  _createElementVNode("div", { class: "flex mx-auto text-white text-2xl font-medium" }, "Let's get to know each other"),
                  _createElementVNode("div", { class: "text-brand-light-gray text-lg" }, "What type of account would you like to create?")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountTypes, (a, aIndex) => {
                  return _createVNode(InputCheckbox, {
                    key: aIndex,
                    name: "accountType",
                    modelValue: accountType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountType).value = $event)),
                    "return-single-value": true,
                    option: a
                  }, null, 8, ["modelValue", "option"])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_5, [
                (accountType.value[0] === _unref(AccountType).Individual)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "For singles or couples who would like their own profile. Profiles can be linked together so you are presented as a couple to the community."))
                  : _createCommentVNode("", true),
                (accountType.value[0] === _unref(AccountType).Joint)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Perfect for couples who'd like to share a single account and profile, your profile is based on your collective desires and interests."))
                  : _createCommentVNode("", true),
                (accountType.value[0] === _unref(AccountType).Club)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "For clubs and businesses."))
                  : _createCommentVNode("", true),
                (accountType.value[0] === _unref(AccountType).Host)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "For event organisers."))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: forward,
                  class: _normalizeClass([{
                  'bg-opacity-40' : !canProgress.value
                }, "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                    _createElementVNode("div", { class: "my-auto pt-0.5" }, [
                      _createElementVNode("div", null, "Continue")
                    ])
                  ], -1)
                ]))], 2)
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})